import { registerArtifactPayload } from '@/features/documentPreview/artifactPayloadStore.js'
import { isUsableHtmlPreview, normalizeGeneratedFileContent } from './generatedFileContent.js'

function previewFile(files) {
  return files.find((file) => file.path.endsWith('/preview.html') || file.path === 'preview.html')
    || files.find((file) => file.path === 'index.html' || file.path.endsWith('/index.html'))
}

export function buildHtmlArtifactFromFiles(files) {
  const html = previewFile(files)
  if (!html || !isUsableHtmlPreview(html.content)) return null
  const artifactId = `backend-html-${Date.now()}-${Math.random().toString(36).slice(2)}`
  return registerArtifactPayload({
    artifactId,
    artifactKind: 'html',
    fileName: html.path,
    displayTitle: html.path,
    description: 'Generated HTML preview',
    payload: { html: normalizeGeneratedFileContent(html.content) },
  })
}

export function buildProjectFileBlocks(files, artifact, project) {
  const fileCount = project?.files_count || project?.files?.length || files.length
  if (!fileCount) return []
  const blocks = [
    { type: 'markdown', content: `Created ${fileCount} file${fileCount === 1 ? '' : 's'}.` },
  ]
  if (artifact) {
    blocks.push({
      type: 'fileArtifact',
      fileName: artifact.fileName,
      description: artifact.description,
      artifactKind: artifact.artifactKind,
      artifactId: artifact.artifactId,
      downloadUrl: artifact.downloadUrl,
      downloadFileName: artifact.downloadFileName,
    })
  }
  if (project?.download_url) {
    blocks.push({
      type: 'fileArtifact',
      fileName: `${project.project_id}.zip`,
      description: `Download source ZIP - ${fileCount} files`,
      artifactKind: 'zip',
      downloadUrl: project.download_url,
    })
  }
  return blocks
}
